exports.list = {
    path: '/pemasukan_equipment',
    name: 'pemasukan_equipment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/pemasukan_equipment/List.vue"),
}
exports.show = {
    path: '/pemasukan_equipment/show/:id',
    name: 'pemasukan_equipment_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pemasukan_equipment/Show.vue"),
}